import React from 'react';
import { Link } from 'react-router-dom';
import './PrivacyPolicy.css';

const SUPPORT_EMAIL = 'support@logicalflows.com';

const Support = () => {
  return (
    <div className="legal-page">
      <nav className="legal-nav">
        <Link to="/" className="back-link">
          ← Back to Home
        </Link>
      </nav>
      <div className="legal-container">
        <h1>App Support</h1>
        <p className="last-updated">Last Updated: September 7, 2026</p>

        <div className="highlight">
          <p>
            <strong>Need help with Price Diary?</strong> Use this page for
            support, account requests, subscription questions, and bug reports.
          </p>
        </div>

        <h2>1. Contact Us</h2>
        <div className="contact-info">
          <p>
            <strong>Support email:</strong>{' '}
            <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>
          </p>
          <p>
            <strong>Typical response time:</strong> within 1–2 business days
          </p>
          <p>
            <strong>Website:</strong>{' '}
            <a
              href="https://logicalflows.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://logicalflows.com/
            </a>
          </p>
        </div>

        <h2>2. What to Include in Your Email</h2>
        <ul>
          <li>Your account email (the one used to sign in)</li>
          <li>Device model and OS version (iOS or Android)</li>
          <li>App version from Profile / About</li>
          <li>A short description of the issue and steps to reproduce</li>
          <li>Screenshots if useful (hide personal data)</li>
        </ul>

        <h2>3. Common Topics We Can Help With</h2>
        <ul>
          <li>Sign-in, Apple Sign-In, Google Sign-In, or account access</li>
          <li>Bill scanning, Quick Add, Bazaar, or voice expense entry</li>
          <li>Subscriptions, renewals, restores, and refunds guidance</li>
          <li>Notifications, location/city detection, and privacy settings</li>
          <li>Data export / account deletion requests</li>
          <li>Crash reports and unexpected behavior</li>
        </ul>

        <h2>4. Subscriptions &amp; Billing</h2>
        <p>
          Price Diary offers optional Pro and Premium subscriptions managed by
          Apple App Store or Google Play.
        </p>
        <ul>
          <li>
            <strong>iOS:</strong> Manage or cancel in iPhone Settings → Apple ID
            → Subscriptions
          </li>
          <li>
            <strong>Android:</strong> Manage in Google Play → Payments &amp;
            subscriptions
          </li>
          <li>
            For billing disputes on Apple purchases, you can also use{' '}
            <a
              href="https://reportaproblem.apple.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              reportaproblem.apple.com
            </a>
          </li>
        </ul>

        <h2>5. Account &amp; Data Deletion</h2>
        <p>
          To delete your account and associated data, email{' '}
          <a href={`mailto:${SUPPORT_EMAIL}?subject=Account%20Deletion%20Request`}>
            {SUPPORT_EMAIL}
          </a>{' '}
          with the subject “Account Deletion Request” and the email address on
          your Price Diary account. We will process requests as described in our{' '}
          <Link to="/privacy-policy">Privacy Policy</Link>.
        </p>

        <h2>6. Legal &amp; Policies</h2>
        <ul>
          <li>
            <Link to="/privacy-policy">Privacy Policy</Link>
          </li>
          <li>
            <Link to="/terms-of-service">Terms of Service</Link>
          </li>
        </ul>

        <h2>7. Download</h2>
        <ul>
          <li>
            <a
              href="https://play.google.com/store/apps/details?id=com.priceDairy.app"
              target="_blank"
              rel="noopener noreferrer"
            >
              Google Play — Price Diary
            </a>
          </li>
          <li>
            <a
              href="https://apps.apple.com/app/id6809188323"
              target="_blank"
              rel="noopener noreferrer"
            >
              App Store — Price Diary Expense Tracker
            </a>
          </li>
        </ul>

        <p style={{ marginTop: '30px', textAlign: 'center', color: '#7f8c8d' }}>
          © 2026 PriceDiary / Logical Flows. All rights reserved.
        </p>
      </div>
    </div>
  );
};

export default Support;
